module.exports = new __parcel__URL__("musica_gameover.5ae121e1.mp3").toString();